import { render, staticRenderFns } from "./aboutShengrongAn.vue?vue&type=template&id=398daaaa&scoped=true"
import script from "./aboutShengrongAn.vue?vue&type=script&lang=js"
export * from "./aboutShengrongAn.vue?vue&type=script&lang=js"
import style0 from "./aboutShengrongAn.vue?vue&type=style&index=0&id=398daaaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398daaaa",
  null
  
)

export default component.exports